import {
  GET_PROGRAM_MEMBERSHIPS_STATS,
  GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS,
  GET_PROGRAM_MEMBERSHIPS_STATS_ERROR,
  GET_PROGRAM_MEMBERSHIPS_STATS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetProgramMembershipsStats = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROGRAM_MEMBERSHIPS_STATS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PROGRAM_MEMBERSHIPS_STATS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PROGRAM_MEMBERSHIPS_STATS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetProgramMembershipsStats;
